import { sendPv } from '@/utils/logTrack'
const darkParams = {
  md: 'darkmode',
  ctid: 'light',
  ct: 'start'
}
if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)')?.matches) {
  darkParams.ctid = 'night'
}
sendPv(darkParams)
